export default class Offers {
    constructor() {
        this.el = $('.js-offers');

        if (!this.el.length) {
            return false;
        }

        this.slickActive = false;
        this.slickEl = this.el.find('.js-slick');

        this._onResize = this._onResize.bind(this);
        window.addEventListener('resize', this._onResize);
        this._onResize();
    }

    _onResize() {
        let ww = $(window).outerWidth();
        if (ww < 992 && !this.slickActive) {
            this.slickActive = true;
            this.slickEl.slick({
                dots: false,
                infinite: true,
                speed: 450,
                slidesToShow: 1,
                variableWidth: true,
                draggable: true,
                arrows: false,
                cssEase: 'cubic-bezier(0.455, 0.030, 0.515, 0.955)',
            });
        } else if (ww >= 992 && this.slickActive) {
            this.slickActive = false;
            this.slickEl.slick('unslick');
        }

    }
}